module.exports = __webpack_public_path__ + "static/img/nuevos_08.f50e987d.jpg";